/** Preserve SuperJSON Date precision when selecting a historical observation. */
export function observationTimestamp(value: Date | string | null | undefined): string | undefined {
  if (!value) return undefined;
  return value instanceof Date ? value.toISOString() : value;
}
